import React from "react";
import { useSearchParams } from "react-router-dom";
import { PageHeader } from "@/components/UI";
import { StockItems } from "./stock/StockItems";
import { LelyConsumptionTab } from "./stock/LelyConsumptionTab";
import { CountHistory } from "./stock/CountHistory";
import { Reports } from "./stock/Reports";

export default function Stock() {
  const [sp] = useSearchParams();
  const tab = sp.get("t") || "items";
  return (
    <div data-testid="stock-page">
      <PageHeader
        title="Stok Yönetimi"
        subtitle="Stok kalemleri, periyodik sayım ve otomatik gider takibi."
      />
      {tab === "items" && <StockItems />}
      {tab === "lely" && <LelyConsumptionTab />}
      {tab === "counts" && <CountHistory />}
      {tab === "reports" && <Reports />}
    </div>
  );
}
